import { render, staticRenderFns } from "./AccountBlockedNotifier.vue?vue&type=template&id=90fd9002&scoped=true&lang=pug&"
import script from "./AccountBlockedNotifier.vue?vue&type=script&lang=js&"
export * from "./AccountBlockedNotifier.vue?vue&type=script&lang=js&"
import style0 from "./AccountBlockedNotifier.vue?vue&type=style&index=0&id=90fd9002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fd9002",
  null
  
)

export default component.exports